var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 364,
    viewBox: "0 0 251 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_4186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7526 254.751V207.356L166.037 205.381L164.72 254.751L175.253 265.284C129.84 303.976 110.385 293.086 77.8281 261.992L83.7526 254.751Z",
    fill: "#FFCCA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.776 278.524C211.776 278.524 167.845 268.577 164.762 254.209V208.116",
    stroke: "#3F3F3F",
    strokeWidth: 1.20987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0405 208.116V254.209C84.0405 254.209 74.5923 273.232 41.4336 278.979",
    stroke: "#3F3F3F",
    strokeWidth: 1.20987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0703 209.032C85.0703 209.032 96.8631 233.166 115.944 244.373C129.796 252.511 147.716 249.354 157.118 236.079C161.807 229.458 165.38 219.71 165.38 205.381C165.38 205.381 150.102 226.121 127.324 227.094C104.545 228.068 85.0703 209.032 85.0703 209.032Z",
    fill: "#D78D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.48 117.411C183.48 117.411 190.844 227.061 124.555 227.061C58.2671 227.061 63.5861 117.411 63.5861 117.411C63.5861 117.411 60.3852 52.2021 126.8 52.2021C188.615 52.2021 183.48 117.411 183.48 117.411Z",
    fill: "#FFCCA9",
    stroke: "#3F3F3F",
    strokeWidth: 1.20987,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.46 139.047C183.46 139.047 189.665 130.077 197.027 134.429C204.39 138.779 202.048 154.844 197.027 162.876C192.007 170.908 183.905 174.877 179.422 168.708",
    fill: "#EFB992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.46 139.047C183.46 139.047 189.665 130.077 197.027 134.429C204.39 138.779 202.048 154.844 197.027 162.876C192.007 170.908 183.905 174.877 179.422 168.708",
    stroke: "#3F3F3F",
    strokeWidth: 1.20987,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.225 144.469C196.225 144.469 187.928 141.701 182.039 153.919",
    stroke: "#3F3F3F",
    strokeWidth: 0.605464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.07 147.94C186.07 147.94 195.097 152.77 189.136 160.026",
    stroke: "#3F3F3F",
    strokeWidth: 0.605464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0299 139.047C64.0299 139.047 57.8249 130.077 50.462 134.429C43.099 138.779 45.4415 154.844 50.462 162.876C55.4824 170.908 63.5853 174.877 68.067 168.708",
    fill: "#EFB992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0299 139.047C64.0299 139.047 57.8249 130.077 50.462 134.429C43.099 138.779 45.4415 154.844 50.462 162.876C55.4824 170.908 63.5853 174.877 68.067 168.708",
    stroke: "#3F3F3F",
    strokeWidth: 1.20987,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2656 144.469C51.2656 144.469 59.5632 141.701 65.4517 153.919",
    stroke: "#3F3F3F",
    strokeWidth: 0.605464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4297 147.939C61.4297 147.939 52.4017 152.769 58.3653 160.025",
    stroke: "#3F3F3F",
    strokeWidth: 0.605464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.791 82.993C185.791 72.6387 179.709 63.2508 170.259 59.0189L159.306 53.2184C154.18 40.348 143.389 28.7288 120.995 29.3163C118.921 29.3703 116.869 29.763 114.898 30.4118C108.647 32.4717 95.9324 38.1982 93.0215 51.0844L78.0416 59.0189C68.5913 63.2508 62.5091 72.6387 62.5091 82.993V122.099C62.4075 124.882 62.399 127.619 62.5091 130.245V130.636C62.5091 130.636 62.5091 130.504 62.5112 130.3C62.6192 132.824 62.832 135.245 63.1908 137.484C63.1908 137.484 76.7206 110.334 74.1643 93.4669C73.2688 87.5562 74.1336 81.4243 77.5102 76.4896C78.3867 75.2098 79.3234 74.0137 80.3237 72.9192C84.9007 67.9199 89.8217 64.5539 94.4939 62.2484C97.6493 71.3886 106.391 84.3966 130.58 89.8151C130.58 89.8151 114.681 79.2078 105.76 66.5989C113.527 73.9925 129.951 83.7519 163.428 86.0605C163.428 86.0605 164.48 77.1628 162.816 66.4189C165.165 68.1221 167.479 70.1078 169.674 72.5064C169.707 72.5403 169.739 72.5763 169.77 72.6101C174.69 78.0434 176.353 85.6848 174.764 92.8392C170.257 113.128 183.56 137.484 183.56 137.484C184.125 133.948 184.356 129.937 184.358 125.734C184.43 129.076 184.381 131.325 184.365 131.861L185.791 82.993Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.645 136.982V159.97C120.645 160.685 120.783 161.371 121.034 161.999C122.021 164.466 124.859 165.649 127.427 164.965L132.949 163.497",
    stroke: "#3F3F3F",
    strokeWidth: 1.1453,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.433 298.548C270.577 324.451 276.701 353.818 278.394 364.71H-24.7734C-21.7816 351.164 -13.9268 324.405 8.17087 298.524C31.0913 271.68 57.4224 259.732 70.3519 254.853C76.3001 261.236 90.6164 274.677 112.779 278.98C127.56 281.85 139.607 279.445 145.43 278.224C161.238 274.911 172.734 268.063 179.269 263.456C189.776 265.318 219.725 272.066 245.433 298.548Z",
    fill: "#BFC0EF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.273 179.165C106.273 179.165 115.302 185.469 126.244 185.469C137.187 185.469 144.748 179.165 144.748 179.165",
    stroke: "#3F3F3F",
    strokeWidth: 1.1453,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.958 131.988C104.958 135.024 102.496 137.485 99.4606 137.485C96.4248 137.485 93.9648 135.024 93.9648 131.988C93.9648 128.952 96.4248 126.491 99.4606 126.491C102.496 126.491 104.958 128.952 104.958 131.988Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.177 131.988C156.177 135.024 153.716 137.485 150.68 137.485C147.645 137.485 145.184 135.024 145.184 131.988C145.184 128.952 147.645 126.491 150.68 126.491C153.716 126.491 156.177 128.952 156.177 131.988Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.23 106.537C115.793 107.036 113.165 113.359 113.165 113.359H84.2734L94.081 109.133C96.5677 108.188 99.2687 107.611 102.038 107.436L116.23 106.537Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.445 106.537C134.883 107.036 137.509 113.359 137.509 113.359H166.4L156.594 109.133C154.107 108.188 151.406 107.611 148.635 107.436L134.445 106.537Z",
    fill: "#3F3F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_4186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330.453,
    height: 366,
    fill: "white",
    transform: "translate(-40)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.b5ad03a3.svg";
export { ForwardRef as ReactComponent };